import * as React from "react"
import "twin.macro"
import { graphql, Link, useStaticQuery } from "gatsby"

const Announcement = ({ url, thumbnail, category, date, title, blurb }) => (
  <div tw="flex flex-col rounded-lg shadow overflow-hidden hover:shadow-lg transition duration-150 ease-in-out transform hover:-translate-y-2">
    <div tw="flex-shrink-0">
      <Link to={url}>
        <img tw="h-48 w-full object-cover" src={thumbnail} alt="" />
      </Link>
    </div>
    <div tw="flex-1 bg-white p-6 flex flex-col justify-between">
      <div tw="flex-1">
        <Link to={url}>
          <p tw="text-sm leading-5 font-medium text-blue-600">
            {category}. {date}
          </p>
          <h3 tw="mt-2 text-xl leading-7 font-semibold text-gray-900">
            {title}
          </h3>
        </Link>
        <p tw="mt-3 text-base leading-6 text-gray-500">{blurb}</p>
      </div>
      {/*<div tw="mt-6 flex items-center">*/}
      {/*  <div tw="flex-shrink-0">*/}
      {/*    <a href="#">*/}
      {/*      <img*/}
      {/*        tw="h-10 w-10 rounded-full"*/}
      {/*        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"*/}
      {/*        alt=""*/}
      {/*      />*/}
      {/*    </a>*/}
      {/*  </div>*/}
      {/*  <div tw="ml-3">*/}
      {/*    <p tw="text-sm leading-5 font-medium text-gray-900">*/}
      {/*      <a href="#" tw="hover:underline">*/}
      {/*        Roel Aufderhar*/}
      {/*      </a>*/}
      {/*    </p>*/}
      {/*    <div tw="flex text-sm leading-5 text-gray-500">*/}
      {/*      <time dateTime="2020-03-16">Mar 16, 2020</time>*/}
      {/*      <span tw="mx-1">·</span>*/}
      {/*      <span>6 min read</span>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  </div>
)

export default function Announcements() {
  const data = useStaticQuery(graphql`
    query {
      allMdx(
        filter: { fileAbsolutePath: { regex: "/announcements/" } }
        limit: 3
        sort: { fields: frontmatter___date, order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              date(formatString: "MMM DD, YYYY")
              path
              title
              category
              thumbnail
              blurb
            }
          }
        }
      }
    }
  `)
  return (
    <div tw="relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
      {/*<div tw="absolute inset-0">*/}
      {/*  <div tw="bg-white h-1/3 sm:h-2/3" />*/}
      {/*</div>*/}
      <div tw="relative max-w-7xl mx-auto">
        <div tw="text-center">
          <h2 tw="text-3xl leading-9 tracking-tight font-extrabold text-gray-900 sm:text-4xl sm:leading-10">
            Latest News
          </h2>
          <p tw="mt-3 max-w-2xl mx-auto text-xl leading-7 text-gray-500 sm:mt-4">
            Here's what's happening at Monta Vista FBLA.
          </p>
        </div>
        <div tw="mt-12 grid gap-5 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
          <div />
          {data.allMdx.edges.map(({ node }) => (
            <Announcement
              url={`/announcements/${node.frontmatter.path}`}
              blurb={node.frontmatter.blurb}
              thumbnail={node.frontmatter.thumbnail}
              category={node.frontmatter.category}
              title={node.frontmatter.title}
              date={node.frontmatter.date}
            />
          ))}
          <div />
        </div>
      </div>
    </div>
  )
}
